import { createRedux } from 'src/firebase';
import { TrendingCategory } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: trendingCategoriesReducer,
  docReducer: trendingCategoryDetailReducer,
} = createRedux<TrendingCategory>('trendingCategories');

export {
  actions,
  actionTypes,
  trendingCategoriesReducer,
  trendingCategoryDetailReducer,
};



// WEBPACK FOOTER //
// ./src/trendingCategories/redux.ts